// import { WebStorageStateStore } from 'oidc-client-ts';
const CLIENT_ID = 'sts.user.ui';

export const SINGIN_REDIRECT_URL = '/signin-oidc';

export const getOidcConfig = (configJSon, isDebugMode = false) => {
    const { debugRedirect, authority } = configJSon;

    const port = window.location.port ? `:${window.location.port}` : '';
    const hostUrl = window.location.protocol + '//' + window.location.hostname + port;

    // Changelog https://github.com/authts/oidc-client-ts/blob/main/docs/migration.md#oidc-client-v1115--oidc-client-ts-v200
    const oidcUserManagerConfig = {
        client_id: CLIENT_ID,
        redirect_uri: `${hostUrl}${SINGIN_REDIRECT_URL}`,
        response_type: 'code',
        scope: 'openid profile email roles api.sts.admin api.users approles api.iam.alert permissions api.users.import',
        authority: isDebugMode ? `https://${debugRedirect.sts}` : authority,
        silent_redirect_uri: `${hostUrl}/silent_renew.html`,
        automaticSilentRenew: true,
        monitorSession: true,
        validateSubOnSilentRenew: true,
        includeIdTokenInSilentRenew: true,
        loadUserInfo: true,
        post_logout_redirect_uri: `${hostUrl}/logout-success`,
        mergeClaimsStrategy: {
            array: 'replace',
        },
        response_mode: null,
        // userStore: new WebStorageStateStore({ store: window.localStorage }),
    };

    return oidcUserManagerConfig;
};
